// @ts-nocheck
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { isMobile } from '../../utils/utils';
import snsEnv from '../../env/env-sns';
import { logger } from '../../logservice/logger';

export default function (options = {}) {
  const { headers = {} } = options;
  const snsAxiosClient = axios.create({
    headers: { ...headers },
  });

  // Request interceptor
  snsAxiosClient.interceptors.request.use(
    function (config) {
      logger.logSuccess('API-Call-req-success', config?.url, null, config?.data);
      config.headers['x-swy-correlation-id'] = uuidv4();
      config.headers['x-swy-date'] = new Date()?.toISOString() || '2999-01-01';
      if (config.headers.data) {
        config.data = { ...config.headers.data };
        const { data, ...rest } = config.headers;
        config.headers = { ...rest };
      } else {
        config.headers = { ...config.headers };
      }
      return config;
    },
    function (error) {
      logger.logSuccess('API-Call-req-error', null, null, error);
      return Promise.reject(error);
    },
  );
  snsAxiosClient.interceptors.response.use(
    function (response) {
      logger.logSuccess('API-Call-mobile-success', response?.request?.bttXhrUrl , null, response);
      logger.logSuccess('API-Call-res-success', response?.request?.bttXhrUrl , null, response?.data);
      return response;
    },
    function (error) {
    const url = error?.request?.bttXhrUrl || error?.request?.responseURL || error?.config?.url;
    const errorData = error?.response?.data || error.message + '-Unknown';
    const status = error?.response?.status || error?.status || error?.code + '-Unknown' ;

    logger.logSuccess('API-Call-mobile-error', url , null, error);

    
    logger.logError('API-Call-res-error', url, null, {
      status: status,
      error: errorData,
      dataConfig: { 
        data: error?.config?.data, 
        url: url, 
        message: error?.config?.message,
        errorType: error.constructor.name, // This helps identify error type
        unknownError: url === undefined ? error : undefined
      },
    });



      const banner = document.getElementById('banner').dataset.banner;
      const env = document.getElementById('env').dataset.env;
      const appData = snsEnv(banner, env, 'web');

      if (error.response.data.errors && error.response.data.errors[0].code === 'OSAR_SNS_0010') {
        // Reload the page for session expiry to redirect to re-sign page
        if (!isMobile()) {
          window.location.assign(appData.RE_SIGN_IN_URL);
        }
      } else if (error.response.data.errorCode === 'PERC0001') {
        //This condition is only for P13 api unauthorized error. Need to check with P13 team to verify the error code
        if (!isMobile()) {
          window.location.assign(appData.RE_SIGN_IN_URL);
        }
      } else {
        return Promise.reject(error);
      }
    },
  );

  return snsAxiosClient;
}
